module.exports = __webpack_public_path__ + "static/media/learning-center.eb552c5a.svg";